import { IconSpinner } from "@/assets/icons/geist/IconSpinner";
import { IconCircleCheck } from "central-icons/IconCircleCheck";
import { IconCircleDotted } from "central-icons/IconCircleDotted";
import { IconTriangleExclamation } from "central-icons/IconTriangleExclamation";
import {
    WorkflowExecutionAction_Status_StepStatus_StepPhase,
    type WorkflowExecutionAction_Status_StepStatus,
} from "gitpod-next-api/gitpod/v1/workflow_pb";
import type { FC } from "react";
import { withGitpodSize, type BaseIconProps } from "@/assets/icons/utils";
import { cn } from "@/components/podkit/lib/cn";
import type { PlainMessage } from "@bufbuild/protobuf";

const IconCircleCheckWithSize = withGitpodSize(IconCircleCheck);
const IconCircleDottedWithSize = withGitpodSize(IconCircleDotted);
const IconTriangleExclamationWithSize = withGitpodSize(IconTriangleExclamation);

export const WorkflowExecutionActionStepStatusIcon: FC<{
    step: PlainMessage<WorkflowExecutionAction_Status_StepStatus>;
    size?: "sm" | "base" | "lg";
}> = ({ step, size = "sm" }) => {
    const phase = step.phase;

    let Icon: FC<BaseIconProps> | null = null;
    let className = "";
    switch (phase) {
        case WorkflowExecutionAction_Status_StepStatus_StepPhase.PENDING:
            Icon = IconCircleDottedWithSize;
            className = "text-content-muted";
            break;
        case WorkflowExecutionAction_Status_StepStatus_StepPhase.RUNNING:
            Icon = IconSpinner;
            className = "animate-spin text-content-muted";
            break;
        case WorkflowExecutionAction_Status_StepStatus_StepPhase.FAILED:
            Icon = IconTriangleExclamationWithSize;
            className = "text-content-destructive";
            break;
        case WorkflowExecutionAction_Status_StepStatus_StepPhase.DONE:
            Icon = IconCircleCheckWithSize;
            className = "text-content-success";
            break;
        case WorkflowExecutionAction_Status_StepStatus_StepPhase.UNSPECIFIED:
            Icon = IconCircleDottedWithSize;
            className = "text-content-muted";
            break;
    }

    if (!Icon) {
        return null;
    }

    return <Icon size={size} className={cn("shrink-0", className)} aria-hidden />;
};
